import { useState, useEffect } from 'react';
import { css } from '@eti/styles';
import { useSiteContext, useTranslation } from '@eti/providers';
import { Button, Inline, Stack, Text, textVariants, Tooltip } from '@etg/wings';
import { price as priceUtil } from '@eti/utils';
import { getSeatIconComponent } from '../../utils/getSeatIconComponent';
import { seatButtonStyles } from '../../utils/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const selectedSeatInitialsStyles = css`
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
`;
const BookableSeat = _ref => {
  let {
    carrier,
    column,
    row,
    onChange,
    price,
    seat,
    isSelected,
    mainCharacteristic,
    markup,
    selectedSeatInitials
  } = _ref;
  const {
    brand
  } = useSiteContext();
  const {
    t
  } = useTranslation();
  const seatNumber = `seat_${seat}`;
  const tooltipSeatLabel = t('Product.SeatMap.Tooltip.Select');
  const tooltipPriceLabel = t('Product.SeatMap.Tooltip.Price');
  const [SeatIconComponent, setSeatIconComponent] = useState();
  useEffect(() => {
    const loadIcon = async () => {
      const iconComponent = await getSeatIconComponent(brand.code, mainCharacteristic, isSelected);
      setSeatIconComponent(() => iconComponent);
    };
    loadIcon();
  }, [brand, mainCharacteristic, isSelected]);
  return isSelected ? /*#__PURE__*/_jsxs(Button, {
    "aria-describedby": seatNumber,
    className: seatButtonStyles,
    "data-testid": `bookableSeat-${row}-${seat}`,
    onClick: onChange({
      price,
      carrier,
      column,
      row,
      seat,
      markup
    }),
    children: [/*#__PURE__*/_jsx(Text, {
      className: selectedSeatInitialsStyles,
      variant: textVariants._12_BOLD,
      children: selectedSeatInitials
    }), SeatIconComponent && /*#__PURE__*/_jsx(SeatIconComponent, {})]
  }) : /*#__PURE__*/_jsx(Tooltip, {
    content: /*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsxs(Inline, {
        children: [tooltipSeatLabel, /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: seat
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        children: [tooltipPriceLabel, /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: priceUtil.formatPrice(price)
        })]
      })]
    }),
    title: "",
    children: /*#__PURE__*/_jsx(Button, {
      "aria-describedby": seatNumber,
      className: seatButtonStyles,
      "data-testid": `bookableSeat-${row}-${seat}`,
      onClick: onChange({
        price,
        carrier,
        column,
        row,
        seat,
        markup
      }),
      children: SeatIconComponent && /*#__PURE__*/_jsx(SeatIconComponent, {})
    })
  });
};
export default BookableSeat;
//# sourceMappingURL=BookableSeat.js.map